import { Link } from "react-router-dom";

const NAV_LINKS = [
  ["/", "Home"],
  ["/sponsors", "Sponsors"],
  ["/tracks", "Tracks"],
  ["/schedule", "Schedule"],
  ["/login", "Login"],
  ["/apply", "Apply"],
];

// A darker step of the page's navy on the same max-width and gutters as the
// content column. Three top-aligned columns under small muted labels, then a
// separate bottom bar for the copyright so it doesn't read as a caption of
// whatever sits above it. The nav is a vertical list on purpose: a wrapping
// row turns "Apply" into an orphan at in-between widths.
export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.08] bg-[#080A28] mt-auto">
      <div className="mx-auto max-w-6xl px-6 sm:px-8 pt-10 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 items-start gap-10 md:gap-6 text-center md:text-left">
          {/* Brand: the wordmark is its own header for this column. The code
              of conduct is a link inside the sentence, not a co-brand. */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <div className="font-space-grotesk text-base leading-none">
              <span className="font-bold tracking-wider uppercase bg-gradient-to-r from-cyan-400 via-sky-400 to-indigo-400 bg-clip-text text-transparent">
                SteelHacks XIII
              </span>
            </div>
            <p className="font-space-grotesk text-xs text-gray-300">
              hosted by{" "}
              <a
                href="https://pittcsc.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-400 hover:text-cyan-300 transition-colors"
              >
                PittCSC
              </a>
            </p>
            <p className="font-space-grotesk text-xs text-gray-300 max-w-[17rem] leading-relaxed">
              We participate in Major League Hacking. All attendees must abide
              by the{" "}
              <a
                href="https://github.com/MLH/mlh-policies/blob/main/code-of-conduct.md"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-400 hover:text-cyan-300 transition-colors"
              >
                MLH Code of Conduct
              </a>{" "}
              during the event.
            </p>
          </div>

          {/* Navigate: mirrors the header's links and labels exactly. */}
          <div>
            <p className="font-space-grotesk text-[11px] font-semibold uppercase tracking-wider text-gray-500 mb-3">
              Navigate
            </p>
            <ul className="space-y-2">
              {NAV_LINKS.map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="font-space-grotesk text-sm font-medium text-gray-300 hover:text-cyan-300 transition-colors duration-200"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Get involved: the way in for a company that wants to sponsor.
              The nav's "Sponsors" is the wall of who already has, so without
              this the pitch page has nothing linking to it. */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="font-space-grotesk text-[11px] font-semibold uppercase tracking-wider text-gray-500">
              Get involved
            </p>
            <Link
              to="/sponsorship"
              className="font-space-grotesk inline-flex items-center gap-2 rounded-xl border border-cyan-400/40 bg-cyan-400/10 px-4 py-2 text-sm font-semibold text-cyan-200 hover:bg-cyan-400/20 transition-colors"
            >
              Sponsor SteelHacks
            </Link>
            <a
              href="mailto:pittcsc@gmail.com"
              className="font-space-grotesk text-xs text-gray-300 hover:text-cyan-300 transition-colors"
            >
              pittcsc@gmail.com
            </a>
          </div>
        </div>

        {/* Bottom bar: copyright on its own line behind a hairline rule. */}
        <div className="mt-8 border-t border-white/[0.08] pt-4 flex flex-col sm:flex-row items-center justify-between gap-1.5 font-space-grotesk text-xs text-gray-400">
          <p>&copy; {new Date().getFullYear()} SteelHacks</p>
          <p>Pittsburgh, PA &middot; September 19&ndash;20, 2026</p>
        </div>
      </div>
    </footer>
  );
}
